import breakpoints from "@shared/theme/props/breakpoints";
import useMediaQuery from "@shared/hooks/useMediaQuery/useMediaQuery";

const { sm } = breakpoints;

/**
 * Utility hook for creating a resize listener that updates a state when the window is resized.
 *
 * Note that this is open to the same issues found during server-side rendering, where this will return `false`
 * on first mount
 */
export const useIsSmallerThanSm = () => {
  const [isSmallerThanSm] = useMediaQuery(`(max-width: ${sm - 1}px)`);

  return isSmallerThanSm;
};
